import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { BasePageComponent, NoResultComponent, FieldWrapperComponent, AbstractPageComponent } from '@spike/scaffolds';
import { InputText } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonGroup } from 'primeng/buttongroup';
import { OrganizationSidePanelComponent } from '../../panels/organization-side-panel/organization-side-panel';
import { EtiquetteListComponent } from 'src/app/features/configuration/components/etiquette-list/etiquette-list';
import { OrganizationsTableComponent } from '../../components/organizations-table/organizations-table';
import { OrganizationStoreService } from '../../services/organization-store.service';
import { EtiquetteStoreService } from 'src/app/features/configuration/services/etiquette-store.service';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';
import { BaseOrganizationEntity } from '../../models/organization-base-entity';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-organization-page',
  providers:[],
  imports: [BasePageComponent, OrganizationSidePanelComponent,  EtiquetteListComponent, NoResultComponent, OrganizationsTableComponent, FieldWrapperComponent, Button, InputText, FormsModule, CommonModule, ButtonGroup],
  templateUrl: './organization-page.html'
})
export class OrganizationPageComponent extends AbstractPageComponent{
  private readonly organizationStore = inject(OrganizationStoreService);
  private readonly etiquetteStoreService = inject(EtiquetteStoreService);


  // Inputs
  entityApi = input.required<EntityApiEnum>();
  modelApi = input.required<ModelApiEnum>();
  etiquetteApi = input.required<EtiquetteApiEnum>();
  entityKey = input.required<string>();
  

  public filter = signal<any>({ stateId: 1, etiquetteId:null });
  public readonly entityList = this.organizationStore.getFilteredList<BaseOrganizationEntity>(this.entityApi, this.filter); 
  public readonly entityEtiquetteList = this.etiquetteStoreService.getReactiveList(this.etiquetteApi);


  //local state
  public isDialogVisible = signal(false);
  public selectedItem = signal<number|undefined>(undefined);
  

  public onSelect(item?: any): void {
      this.selectedItem.set(item[this.entityKey()]);
      this.isDialogVisible.set(true);
  }
  public onInsert(): void {
      this.onSelect({});
  }

  public onClose(): void {
     setTimeout(() => {
      this.selectedItem.set(undefined)
      this.isDialogVisible.set(false);
    }, 200);
    
  }

  public onSearchByShortDesc(searchKey: any): void {
    this.filter.update(f => ({ ...f, shortDescription: searchKey }));
  }
  
  
  public searchByEtiquette(etiquetteId: number | null): void {
    this.filter.update(f => ({ ...f, etiquetteId }));
  }

  changeState(stateId: 0|1){
    this.filter.update(f => ({ ...f, stateId: stateId }));
  }


}